module.exports = __webpack_public_path__ + "static/media/daily-bonus-prizes-bottom-bar.e6569e39.png";